/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaChoiceText/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaChoiceText({
  children,
  viewPath = "/DesignSystem/TysiaChoice/TysiaChoiceText",
  text = "Default text",
  color,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  maginBottom = 0,
  type,
  hovered,
  selected,
  disabled
  
}) {
let dtTysiachoicetextColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoiceText.color.primary.base'
        })
let dtTysiachoicetextTypographyFontsizeBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoiceText.typography.fontSize.base'
        })
let dtTysiachoicetextTypographyLineheightBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoiceText.typography.lineHeight.base'
        })
let dtTysiachoicetextColorPrimaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoiceText.color.primary.hovered'
        })
let dtTysiachoicetextColorPrimarySelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoiceText.color.primary.selected'
        })
let dtTysiachoicetextColorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoiceText.color.primary.disabled'
        })
let dtTysiachoicetextColorSecondaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoiceText.color.secondary.hovered'
        })
let dtTysiachoicetextColorSecondarySelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoiceText.color.secondary.selected'
        })
let dtTysiachoicetextColorSecondaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoiceText.color.secondary.disabled'
        })
let dtTysiachoicetextColorSecondaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoiceText.color.secondary.base'
        })
let dtTysiachoicetextColorDangerHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoiceText.color.danger.hovered'
        })
let dtTysiachoicetextColorDangerSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoiceText.color.danger.selected'
        })
let dtTysiachoicetextColorDangerDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoiceText.color.danger.disabled'
        })
let dtTysiachoicetextColorDangerBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoiceText.color.danger.base'
        })
let dtTysiachoicetextColorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoiceText.color.brand.hovered'
        })
let dtTysiachoicetextColorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoiceText.color.brand.selected'
        })
let dtTysiachoicetextColorBrandDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoiceText.color.brand.disabled'
        })
let dtTysiachoicetextColorBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaChoiceText.color.brand.base'
        })
let colorOrdtTysiachoicetextColorPrimaryBase = color ?? dtTysiachoicetextColorPrimaryBase
let colorOrdtTysiachoicetextColorPrimaryBase1 = color ?? dtTysiachoicetextColorPrimaryBase
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text={text}
 color={type === "primary" && hovered ? dtTysiachoicetextColorPrimaryHovered : type === "primary" && selected ? dtTysiachoicetextColorPrimarySelected : type === "primary" && disabled ? dtTysiachoicetextColorPrimaryDisabled : type === "primary" ? dtTysiachoicetextColorPrimaryBase : type === "secondary" && hovered ? dtTysiachoicetextColorSecondaryHovered : type === "secondary" && selected ? dtTysiachoicetextColorSecondarySelected : type === "secondary" && disabled ? dtTysiachoicetextColorSecondaryDisabled : type === "secondary" ? dtTysiachoicetextColorSecondaryBase : type === "danger" && hovered ? dtTysiachoicetextColorDangerHovered : type === "danger" && selected ? dtTysiachoicetextColorDangerSelected : type === "danger" && disabled ? dtTysiachoicetextColorDangerDisabled : type === "danger" ? dtTysiachoicetextColorDangerBase : type === "brand" && hovered ? dtTysiachoicetextColorBrandHovered : type === "brand" && selected ? dtTysiachoicetextColorBrandSelected : type === "brand" && disabled ? dtTysiachoicetextColorBrandDisabled : type === "brand" ? dtTysiachoicetextColorBrandBase : hovered ? dtTysiachoicetextColorPrimaryHovered : selected ? dtTysiachoicetextColorPrimarySelected : disabled ? dtTysiachoicetextColorPrimaryDisabled : colorOrdtTysiachoicetextColorPrimaryBase1}
 fontSize={dtTysiachoicetextTypographyFontsizeBase}
 lineHeight={dtTysiachoicetextTypographyLineheightBase}
 fontWeight={500}
 marginLeft={marginLeft}
 marginRight={marginRight}
 marginTop={marginTop}
 maginBottom={maginBottom}
/>
{children}
</React.Fragment>)
}